module.exports = __webpack_public_path__ + "static/media/metafest-date.74809cde.png";